import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { TOUCH_HEIGHT, NON_TOUCH_HEIGHT } from '../SideNavigation.constants.js';

var _templateObject, _templateObject2;
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: ", ";\n  display: flex;\n  flex-direction: column;\n  height: fit-content;\n  justify-content: center;\n  width: 100%;\n  position: sticky;\n  top: 0;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colours.canvas.tertiary.main;
});
var InfoBar = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  height: ", ";\n  /* A gap is left when isTouch = true to leave enough space for the hamburger button (3.5rem). */\n  padding-left: ", ";\n  width: 100%;\n"])), function (_ref2) {
  var $isTouch = _ref2.$isTouch;
  return $isTouch ? TOUCH_HEIGHT : NON_TOUCH_HEIGHT;
}, function (_ref3) {
  var $isTouch = _ref3.$isTouch;
  return $isTouch ? NON_TOUCH_HEIGHT : 'initial';
});

export { Container, InfoBar };
//# sourceMappingURL=TopBar.styles.js.map
